/*
 * dispenseEproDevicePopupModule
 * */

import lostEproDevicePopupComponent from './lostEproDevicePopup.component';

const lostEproDevicePopupModule = angular.module('app.components.lostEproDevicePopup', [])
	.component('lostEproDevicePopup', lostEproDevicePopupComponent)
	.name;

export default lostEproDevicePopupModule;
